<template>
  <a-card
    :bordered="true"
    class="header-solid h-full"
    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
  >
    <template v-if="withTitle" #title>
      <h4 class="m-text-header-thin m-remove">{{ title }}</h4>
    </template>
    <template slot="extra" class="mb-0">
      <!-- <a-button type="primary"> VIEW ALL </a-button> -->
    </template>
    <a-list
      class="invoice-list"
      item-layout="horizontal"
      :split="false"
      :data-source="data"
      :loading="loading"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta :title="item.title" :description="item.description">
        </a-list-item-meta>
        <div style="padding-left: 10px;" class="amount">{{ item.amount }}</div>
        <div v-if="item.amount2" style="padding-left: 10px;" class="amount">{{ item.amount2 }}</div>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
export default {
  props: {
    withTitle: {
      type: Boolean,
      default: () => true,
    },
    title: {
      type: String,
      default: () => "Title",
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>
